<template>
  <section class="d-grid gap-4">
    <header>
      <h2 class="h4 mb-1">Reportes operativos</h2>
      <p class="text-muted mb-0">
        Ventas, caja, productos, cuentas por cobrar y compras — con export a CSV.
      </p>
    </header>

    <div class="row g-3">
      <div v-for="card in cards" :key="card.to.name" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">{{ card.title }}</h3>
            <p class="text-muted small mb-3">{{ card.description }}</p>
            <router-link class="btn btn-dark btn-sm" :to="card.to">Abrir</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const cards = [
  {
    title: 'Ventas por período',
    description: 'Desglose por método de pago, cajero, caja y sucursal.',
    to: { name: 'ReportesVentas' },
  },
  {
    title: 'Cierres de caja',
    description: 'Historial de aperturas cerradas: declarado vs esperado y diferencias.',
    to: { name: 'ReportesCierresCaja' },
  },
  {
    title: 'Productos vendidos',
    description: 'Más y menos vendidos por período y categoría.',
    to: { name: 'ReportesProductosVendidos' },
  },
  {
    title: 'Cuentas por cobrar',
    description: 'Deuda de clientes crédito con antigüedad (aging).',
    to: { name: 'ReportesCuentasPorCobrar' },
  },
  {
    title: 'Compras por proveedor',
    description: 'Facturas de compra por proveedor y período.',
    to: { name: 'ReportesComprasProveedor' },
  },
]
</script>
